module.exports = __webpack_public_path__ + "static/img/wow.0157ebe6.png";